import React from 'react';

const Landing = () => {
  React.useEffect(() => {
    window.location.href = '/landing/index.html';
  }, []);
 
  return null;
};

export default Landing;